import React from 'react';

// LifeMath brand colors
export const brandColors = {
  navyDark: '#1e3a5f',
  navyMedium: '#2d4a6f',
  bluePrimary: '#3b82f6',
  blueLight: '#60a5fa',
  blueSky: '#0ea5e9',
};

// LM Logo
export const LMLogoIcon = ({ className = "w-8 h-8", color = brandColors.navyDark }) => (
  <svg viewBox="0 0 48 48" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <text x="4" y="36" fontFamily="Arial, sans-serif" fontWeight="bold" fontSize="32" fill={color}>
      LM
    </text>
  </svg>
);

// Dashboard/Grid Icon
export const DashboardIcon = ({ className = "w-6 h-6", color = brandColors.navyDark, accentColor = brandColors.bluePrimary }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    {/* Top row */}
    <rect x="2" y="2" width="6" height="6" rx="1" fill={color} />
    <rect x="9" y="2" width="6" height="6" rx="1" fill={color} />
    <rect x="16" y="2" width="6" height="6" rx="1" fill={accentColor} />
    {/* Bottom row */}
    <rect x="2" y="9" width="6" height="6" rx="1" fill={color} />
    <rect x="9" y="9" width="6" height="6" rx="1" fill={accentColor} />
    <rect x="16" y="9" width="6" height="6" rx="1" fill={color} />
    {/* Third row */}
    <rect x="2" y="16" width="6" height="6" rx="1" fill={color} />
    <rect x="9" y="16" width="6" height="6" rx="1" fill={color} />
    <rect x="16" y="16" width="6" height="6" rx="1" fill={color} />
  </svg>
);

// Slider/Adjustment Icon
export const SliderIcon = ({ className = "w-6 h-6", trackColor = brandColors.navyDark, dotColor = brandColors.navyDark }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <line x1="4" y1="12" x2="20" y2="12" stroke={trackColor} strokeWidth="2" strokeLinecap="round" />
    <circle cx="10" cy="12" r="4" fill={dotColor} />
  </svg>
);

// Chart/Graph Icon (rounded square with upward trend)
export const ChartIcon = ({ className = "w-6 h-6", bgColor = brandColors.navyDark, lineColor = brandColors.bluePrimary }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="2" width="20" height="20" rx="4" fill={bgColor} />
    <path
      d="M6 16 L10 12 L14 14 L18 8"
      stroke={lineColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

// Combined LifeMath Logo with text
export const LifeMathLogo = ({ className = "h-8", showText = true }) => (
  <div className={`flex items-center gap-2 ${className}`}>
    <div className="flex items-center">
      <span className="text-2xl font-bold" style={{ color: brandColors.navyDark }}>L</span>
      <span className="text-2xl font-bold" style={{ color: brandColors.navyDark }}>M</span>
    </div>
    {showText && (
      <span className="text-xl font-semibold" style={{ color: brandColors.bluePrimary }}>LifeMath</span>
    )}
  </div>
);

const BrandIcons = { LMLogoIcon, DashboardIcon, SliderIcon, ChartIcon, LifeMathLogo, brandColors };
export default BrandIcons;
